const TRACKING_SITE_NAVIGATION = 'tracking_site_navigation';
const SCHEDULE_EXPORT_DRAFT = 'schedule-export-draft:';

export { TRACKING_SITE_NAVIGATION, SCHEDULE_EXPORT_DRAFT };
